<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object as PropType<{
      pic: string
      category: string
      date: string
      title: string
      link: string
    }>,
    default: () => {
      return {
        pic: '',
        category: '',
        date: '',
        title: '',
        link: ''
      }
    }
  }
})

const isShow: Ref<boolean> = ref(false)

onMounted(() => {
  isShow.value = true
})
</script>

<template>
  <div class="card">
    <figure class="card__pic square__pic h__pic" :class="{ isShow: isShow }">
      <nuxt-link :to="data.link"><img :src="data.pic" :alt="data.title" /></nuxt-link>
    </figure>
    <div class="card__category" v-if="data.category">{{ data.category }}</div>
    <div class="card__date" v-if="data.date">{{ data.date }}</div>
    <div class="card__title" v-if="data.title">
      <nuxt-link :to="data.link">{{ data.title }}</nuxt-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  &__pic {
    margin-bottom: toRem(10);

    img {
      display: block;
      width: 100%;
    }
  }

  &__category {
    font-weight: 700;
    color: $color-gray-2;
    font-size: toRem(16);
  }

  &__date {
    margin-bottom: toRem(10);
    font-size: toRem(14);
    color: $color-gray-2;
  }

  &__title {
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;
    @include dot-many-line;
  }
}
</style>
